import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../core';
import { PedidoPagamentoHistorico } from '../adapters';

@Injectable({
    providedIn: 'root'
})
export class PedidoPagamentoHttpService {
    private pathApi: string;

    constructor(private customHttp: CustomHttp,
                configServerService: ConfigServerService) {
        this.pathApi = `${configServerService.getPathApi()}/pedido`;
    }

    /** Pesquisa o histórico das últimas condições de pagamentos utilizadas nos pedidos */
    searchHistorico(idPedido: number, idPessoa: number, idRepresentante: number, quantidadeRegistros: number = 3): Observable<PedidoPagamentoHistorico[]> {
        // Params
        let params = new HttpParams();
        // Pessoa
        params = params.append('idPessoa', idPessoa ? idPessoa.toString() : null);
        // Representante
        params = params.append('idRepresentante', idRepresentante ? idRepresentante.toString() : null);
        // Quantidade de registros
        params = params.append('quantidadeRegistros', quantidadeRegistros ? quantidadeRegistros.toString() : null);

        return this.customHttp.get<PedidoPagamentoHistorico[]>(`${this.pathApi}/${idPedido ? idPedido : 0}/condicaopagamento/historico`, {params});
    }
}
